module.exports = __webpack_public_path__ + "media/images/Turquoise-d3eafe8b.webp";